import { createMarkup } from '@packages/domain/utils/createMarkup/createMarkup';
import { Heading } from 'components/ui/Heading/Heading';
import PropTypes from 'prop-types';
import { useTranslations } from 'utils/translations/useTranslations';
import { ReactComponent as ErrorIcon } from '../../../src/icons/error.svg';

export const FetchOffersError = ({ recipientName, errors = [] }) => {
  const i18n = useTranslations();
  return (
    <div
      data-testid="paymentOptionsError"
      className="textAlign-center paddingBottom-xxxxl"
    >
      <ErrorIcon className="marginBottom-lg marginTop-xxxxl" />
      <Heading
        as="h1"
        size="large"
        className="textAlign-center marginBotom-sm fontWeight-semiBold marginBottom-sm"
      >
        {i18n.t('checkout.paymentOptions.error.title')}
      </Heading>
      <p
        className="type-regular paddingH-xxl"
        dangerouslySetInnerHTML={createMarkup(
          i18n.t('checkout.paymentOptions.error.message', {
            recipientName:
              recipientName ||
              i18n.t('checkout.paymentOptions.error.your_institution'),
          }),
        )}
      />
      <p>
        {i18n.t('checkout.paymentOptions.error.type')}
        {': '}
        <span className="fontWeight-bold">
          {errors.length > 0
            ? errors
                .map(err => {
                  const translatedMessage = i18n.t(
                    `validation.${err.message}`,
                    {
                      defaultValue: err.message,
                    },
                  );

                  return `${err.param} ${translatedMessage}`;
                })
                .join(' ')
            : 'Unexpected error'}
        </span>
      </p>
    </div>
  );
};

FetchOffersError.propTypes = {
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      param: PropTypes.string,
      message: PropTypes.string,
      type: PropTypes.string,
    }),
  ),
  recipientName: PropTypes.string,
};
